import React from "react";
import { Inbox } from "lucide-react";
import { useNavigate } from "react-router-dom";

const COLOR_VARIANTS: Record<
  string,
  { bg: string; iconBg: string; text: string; border: string }
> = {
  green: {
    bg: "bg-green-50",
    iconBg: "bg-green-100",
    text: "text-green-800",
    border: "border-green-500",
  },
  teal: {
    bg: "bg-teal-50",
    iconBg: "bg-teal-100",
    text: "text-teal-800",
    border: "border-teal-500",
  },
  red: {
    bg: "bg-red-50",
    iconBg: "bg-red-100",
    text: "text-red-500",
    border: "border-red-500",
  },
  amber: {
    bg: "bg-amber-50",
    iconBg: "bg-amber-100",
    text: "text-amber-500",
    border: "border-amber-500",
  },
  yellow: {
    bg: "bg-yellow-50",
    iconBg: "bg-yellow-100",
    text: "text-yellow-500",
    border: "border-yellow-500",
  },
};

interface LeadsCardProps {
  leadsCount: number;
  title: string;
  icon?: React.ElementType;
  color?: string;
  filterStatus?: string;
  assigneeId?: string;
}

export default function LeadsCard({
  leadsCount,
  title,
  icon: Icon = Inbox,
  color = "red",
  filterStatus,
  assigneeId,
}: LeadsCardProps) {
  const navigate = useNavigate();
  const theme = COLOR_VARIANTS[color] || COLOR_VARIANTS["red"];

  const handleClick = () => {
    if (filterStatus) {
      navigate("/leads", {
        state: { filterStatus, assigneeId },
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex flex-row w-full justify-between items-center  ${
        theme.bg
      } p-4 rounded-xl ${
        filterStatus
          ? "cursor-pointer hover:shadow-md transition-shadow duration-200 hover:border " +
            theme.border
          : ""
      }`}
    >
      <div className="flex flex-row justify-between gap-6">
        <div className="flex flex-col gap-0">
          <p className={`${theme.text} text-xl font-extrabold`}>{leadsCount}</p>
          <p className={`text-xs ${theme.text}`}>{title}</p>
        </div>
      </div>
      <div
        className={`flex flex-col items-center ${theme.iconBg} p-2 rounded-full`}
      >
        <Icon className={`${theme.text} w-10 h-10`} />
      </div>
    </button>
  );
}
